import { createClient } from 'contentful';

const client = createClient({
  space: 'gw0oo92ch11z', // Reemplaza con tu Space ID
  accessToken: 'ow242c6YLRMhc5Ts-JWbedoqoAW7H2LOfuFtE6SM7AQ', // Reemplaza con tu Access Token
});

export default client;
